export const gosReportFields = {
  ID: 'id',
  TRANSACTION_DATE: 'transactionDate',
  TRANSACTION_NUMBER: 'transactionNumber',
  TRANSACTION_STATUS: 'transactionStatus',
  DELIVERY_PERIOD: 'deliveryPeriod',
  SUPPLIED_RENEWABLE_ENERGY: 'suppliedRenewableEnergy',
  NATURAL_ENERGY_AMOUNT: 'naturalEnergyAmount',
  CALCULATED_MULTIPLIER: 'calculatedMultiplier',
  CALCULATED_ENERGY_AMOUNT: 'calculatedEnergyAmount',
  BIOFUEL_TYPE: 'biofuelType',
  GHG_CAPACITY: 'ghgCapacity',
  CONSUMPTION_PERIOD: 'consumptionPeriod',
  CONSUMPTION_PROVIDER: 'consumptionProvider',
  CONSUMPTION_PROVIDER_TRANSACTION_ID: 'consumptionProviderTransactionId',
  PRODUCTION_PERIOD: 'productionPeriod',
  EICW_CODE: 'eicwCode',
  POS_NUMBER: 'posNumber',
  ENERGY_TYPE: 'energyType',
  BIOFUEL_COMPONENT_CN: 'biofuelComponentCn',
  SUSTAINABLE_BIOFUEL: 'sustainableBiofuel',
  FUEL_TYPE: 'fuelType',
  FEEDSTOCK: 'feedstock',
  PRODUCTION_PATHWAY: 'productionPathway',
  AMOUNT: 'amount',
  LOWER_CALORIFIC_VALUE_KG: 'lowerCalorificValueKg',
  HIGHER_CALORIFIC_VALUE_KG: 'higherCalorificValueKg',
  LAND_USE_CATEGORY: 'landUseCategory',
  LAND_USE_EMISSIONS: 'landUseEmissions',
  RFNBO: 'rfnbo',
  HYDROGEN_TECHNOLOGY_TYPE: 'hydrogenTechnologyType',
  RENEWABLE_ENERGY_REPORT_ROW_TYPE: 'renewableEnergyReportRowType',
};
